module.exports = __webpack_public_path__ + "static/media/img-01.b68e1152.jpg";